export default "__VITE_ASSET__sTu3bP8V__"